import type { MouseEvent } from 'react'

/**
 * Keeps native browser link behavior for modifier/middle clicks,
 * while supporting client-side navigation on plain left clicks.
 */
export function createClientNavigationClickHandler(
  navigate: () => void,
): (event: MouseEvent<HTMLElement>) => void {
  return (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey
    ) {
      return
    }

    event.preventDefault()
    navigate()
  }
}
